import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './BlogLayout.module.scss';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { BlogHeader, BlogFooter } from '~/components';

const BlogLayout = ({ isArchivePage, children }) => {
  const breakpoints = useBreakpoint();

  // {/* <div className="header-col">
  //       <Button variant="icon">
  //         <IconSearch />
  //       </Button>
  //     </div> */}

  return (
    <div className="l-container" data-is-root-path={isArchivePage}>
      <BlogHeader />
      {isArchivePage && (
        breakpoints.sm ?
          (
            <StaticImage
              src="./images/hero_mobile.png"
              alt=""
              quality={80}
              className={styles.hero}
            />
          ) : (
            <StaticImage
              src="./images/hero_pc.png"
              alt=""
              quality={80}
              className={styles.hero}
            />
          )
      )}
      {children}
      <BlogFooter />
    </div>
  )
}

export default React.memo(BlogLayout);